var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPolygon = function SvgPolygon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.597,
    cy: 12.733,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.67 10.01a1.012 1.012 0 0 0-1.003 0l-2.302 1.361-1.565.888-2.303 1.362a1.012 1.012 0 0 1-1.003 0l-1.83-1.066a1.021 1.021 0 0 1-.502-.858V9.596a.96.96 0 0 1 .502-.859l1.8-1.036a1.012 1.012 0 0 1 1.004 0l1.8 1.036c.296.178.502.503.502.859v1.361l1.565-.917V8.678a.96.96 0 0 0-.502-.858L9.497 5.866a1.012 1.012 0 0 0-1.003 0L5.099 7.82a.96.96 0 0 0-.502.858v3.937c0 .355.177.68.502.858l3.395 1.954c.295.177.679.177 1.003 0l2.303-1.332 1.565-.918 2.302-1.332a1.012 1.012 0 0 1 1.004 0l1.8 1.036c.296.178.503.503.503.858v2.102a.96.96 0 0 1-.502.858l-1.801 1.066a1.012 1.012 0 0 1-1.004 0l-1.8-1.036a1.021 1.021 0 0 1-.502-.859V14.51l-1.565.918v1.361c0 .355.177.68.502.858l3.395 1.954c.295.177.679.177 1.003 0l3.395-1.954c.295-.177.502-.503.502-.858v-3.937a.96.96 0 0 0-.502-.858l-3.424-1.983Z",
    fill: "#000"
  })));
};

export default SvgPolygon;